"use client";

import { usePathname, useRouter } from "next/navigation";
import { JSX, useEffect } from "react";
import { PATHS } from "rivals/shared/constants";
import { Props } from "./types";

/**
 * Listens to changes in autentication state
 * Pages wrapped with this component require authentication to visit
 * If the user is not authenticated:
 *
 * a) They should be redirected to the Login page
 * b) They should not see the page content
 *
 * Shared logic, router agnostic
 */
export default function ProtectedPage({
  isAuthenticated,
  children
}: Props): JSX.Element | null {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (!isAuthenticated && pathname !== PATHS.SIGN_IN) {
      router.push(PATHS.SIGN_IN);
    }
  }, [isAuthenticated, pathname, router]);

  // Unauthenticated users should not see the page content
  return isAuthenticated ? <>{children}</> : null;
}
